import moment from 'moment'
import { $t, i18next } from '../i18n'
import store from '../store'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * Retourne les données d'en-tête de la page des contacts générés par les portails.
 *
 * @param {string} id
 * @returns {object}
 */
export async function getContactsPortailsEnTete (filter) {
  const user = store.getters.getUser
  let url = '/contacts_portails_en_tete' + '?annonceur=' + user.advertiser

  if (filter.beforeContacts != null) {
    const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
    url = url + '&dateMin=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&dateMin=' + before
  }

  if (filter.afterContacts != null) {
    const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
    url = url + '&dateMax=' + dateAfter
  }

  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return {
      infos: response.data
    }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export async function getContactsStatsEnTete (filter) {
  const user = store.getters.getUser
  let url = '/contacts_stats' + '?annonceur=' + user.advertiser

  if (filter.negociateur) {
    url = url + '&negociateur_code=' + filter.negociateur
  }

  if (filter.beforeContacts != null) {
    const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
    url = url + '&date-min-contact-mailtracking=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&date-min-contact-mailtracking=' + before
  }

  if (filter.afterContacts != null) {
    const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
    url = url + '&date-max-contact-mailtracking=' + dateAfter
  }

  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return {
      infos: response.data
    }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export async function getContactsPortails (filter) {
  const user = store.getters.getUser
  let url = '/contacts_stats_by_portals' + '?annonceur=' + user.advertiser

  if (filter.beforeContacts != null) {
    const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
    url = url + '&date-min-contact-mailtracking=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&date-min-contact-mailtracking=' + before
  }

  if (filter.afterContacts != null) {
    const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
    url = url + '&date-max-contact-mailtracking=' + dateAfter
  }
  if (filter.negociateur_code != null) {
    url = url + '&negociateur_code=' + filter.negociateur_code
  }

  url = url + '&type=contact,rapprochement'
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return {
      infos: response.data
    }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export async function getContactsPortailEnTete (filter, idDiffuseur) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      let url = '/contacts_stats' + '?annonceur=' + user.advertiser
      if (filter.beforeContacts != null) {
        const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
        url = url + '&dateMin=' + dateBefore
      } else {
        const dateBefore = moment().subtract(7, 'days')
        const before = moment(dateBefore).format('YYYY-MM-DD')
        url = url + '&date-min-contact-mailtracking=' + before
      }

      if (filter.afterContacts != null) {
        const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
        url = url + '&date-max-contact-mailtracking=' + dateAfter
      }

      return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * Retourne les données d'en-tête de la page des contacts générés par les annonces.
 *
 * @param {string} id
 * @returns {object}
 */
export async function getContactsAnnoncesEnTete (filter) {
  const user = store.getters.getUser
  let url = '/contacts_stats' + '?annonceur=' + user.advertiser
  if (filter.beforeContacts != null) {
    const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
    url = url + '&dateMin=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&dateMin=' + before
  }

  if (filter.afterContacts != null) {
    const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
    url = url + '&dateMax=' + dateAfter
  }

  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return {
      infos: response.data
    }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export async function getContactsAll (filter) {
  const user = store.getters.getUser
  if (!filter.page) {
    filter.page = 1
  }
  if (!filter.limit) {
    filter.limit = 10
  }
  let url = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL + '/contacts'
  url = url + '?annonceur=' + user.advertiser + '&type=contact&page=' + filter.page + '&perPage=' + filter.limit
  if (filter.beforeContacts != null) {
    const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
    url = url + '&date_min=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&date_min=' + before
  }
  if (filter.afterContacts != null) {
    const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
    url = url + '&date_max=' + dateAfter
  }
  if (filter.search) {
    url = url + '&globalSearch=' + filter.search
  }
  if (filter.reference) {
    url = url + '&reference=' + filter.reference
  }
  if (filter.mail) {
    url = url + '&mail=' + filter.mail
  }
  if (filter.negociateur != null) {
    url = url + '&negociateur_code=' + filter.negociateur
  }
  if ((filter.direction !== null)) {
    if ((filter.sort !== null && filter.sort === 'date')) {
      url = `${url}&direction=${filter.direction}&sort=${filter.sort}`
    }
    if ((filter.sort !== null && filter.sort === 'reference')) {
      url = `${url}&direction=${filter.direction}&sort=${filter.sort}`
    }
    if ((filter.sort !== null && filter.sort === 'nomPortail')) {
      url = `${url}&direction=${filter.direction}&sort=${filter.sort}`
    }
  }
  console.log(url)
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return response.data
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

/**
* Retourne les données d'en-tête de la page des contacts générés par les annonces.
*
* @param {string} id
* @returns {object}
*/
export async function getContactsAnnonceEnTete (filter, reference) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      let url = '/contacts_stats' + '?annonceur=' + user.advertiser + '&reference=' + reference
      if (filter.beforeContacts != null) {
        const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
        url = url + '&dateMin=' + dateBefore
      } else {
        const dateBefore = moment().subtract(7, 'days')
        const before = moment(dateBefore).format('YYYY-MM-DD')
        url = url + '&dateMin=' + before
      }

      if (filter.afterContacts != null) {
        let dateAfter = moment(filter.afterContacts).add(1, 'days')
        dateAfter = moment(dateAfter).format('YYYY-MM-DD')
        url = url + '&dateMax=' + dateAfter
      }

      return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * Retourne les contacts pour un annonceur donné et des filtres de recherche
 *
 * @param {string} id
 * @returns {object}
 */
export async function getContactsPortail (filter, idDiffuseur) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      let url = '/contacts?annonceur=' + user.advertiser + '&diffuseurs=' + idDiffuseur
      url = url + '&perPage=' + filter.limit + '&page=' + (filter.offset / filter.limit + 1)

      if (i18next.language != null) {
        url = url + '&lang=' + i18next.language
      }

      if (filter.search != null) {
        url = url + '&globalSearch=' + filter.search
      }

      if (filter.rapprochement != null) {
        url = url + '&type=rapprochement'
      }

      let apiTri = '-date_enregistrement'
      switch (filter.sort) {
        case 'date':
          apiTri = '-date_enregistrement'
          break
        case 'reference':
          apiTri = 'reference'
          break
        case 'identite':
          apiTri = 'identite'
          break
      }

      if (filter.beforeContacts != null) {
        const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
        url = url + '&date_min=' + dateBefore
      } else {
        const dateBefore = moment().subtract(7, 'days')
        const before = moment(dateBefore).format('YYYY-MM-DD')
        url = url + '&date_min=' + before
      }

      if (filter.afterContacts != null) {
        const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
        url = url + '&date_max=' + dateAfter
      }

      url = url + '&orderBy=' + apiTri

      return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * Export contacts with filters and some params
 */
export async function exportContacts (filters, prospect = null, reference = null, idDiffuseur = null, filename = null) {
  const user = store.getters.getUser
  // export des contacts réservé aux comptes principales et admin
  if ((filters.forced === false) && user.roles.includes('ROLE_SUB_USER')) {
    return { type: 'error', message: $t('layouts.exportErrorAccess') }
  }
  const sitimmoUser = store.getters.getSitimmoUser
  const normalizedFilters = {}

  normalizedFilters.idAnnonceur = user.advertiser

  if (prospect) {
    normalizedFilters.exportProspects = 'O'
  }
  if (reference) {
    normalizedFilters.reference = reference
  }
  if (idDiffuseur) {
    normalizedFilters.diffuseurs = idDiffuseur
  }
  if (filters.rapprochement != null) {
    normalizedFilters.type = 'rapprochement'
  }

  if (i18next.language != null) {
    normalizedFilters.lang = i18next.language
  }

  if (filters.search != null) {
    normalizedFilters.globalSearch = filters.search
  }

  if (filters.beforeContacts != null) {
    const dateBefore = moment(filters.beforeContacts).format('YYYY-MM-DD')
    normalizedFilters.dateMin = dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    normalizedFilters.dateMin = before
  }

  if (filters.afterContacts != null) {
    const dateAfter = moment(filters.afterContacts).format('YYYY-MM-DD')
    normalizedFilters.dateMax = dateAfter
  }

  if (filters.portalCodeName !== undefined) {
    normalizedFilters.portalCodeName = filters.portalCodeName
    filters.exportType = 'portail_' + sitimmoUser.univers + '_mailtracking'
  }

  let apiTri = '-date_enregistrement'
  switch (filters.sort) {
    case 'date':
      apiTri = '-date_enregistrement'
      break
    case 'reference':
      apiTri = 'reference'
      break
    case 'identite':
      apiTri = 'identite'
      break
  }

  normalizedFilters.orderBy = apiTri

  if (!filters.exportType) {
    filters.exportType = 'annonce_' + sitimmoUser.univers + '_mailtracking'
    if (prospect) {
      filters.exportType += '_prospects'
    }
  }

  if (!filename) {
    filename = 'contact_mailtracking'
  }
  const exportType = filters.exportType
  if (normalizedFilters.orderBy === '-date_enregistrement') {
    normalizedFilters.orderBy = ''
  }
  const data = { filters: normalizedFilters, exportType: exportType, to: sitimmoUser.email, filename: filename, lang: i18next.language }

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/export_requests', data)
    .then(response => {
      if (response.status === 202) {
        return { type: 'success', message: $t('layouts.exportSuccess') }
      }

      // return {type: "error", message: $t("error.found")};
    })
    .catch(error => {
      // return { type: 'error', message: $t('error.found') }
    })
}

/**
* Retourne les contacts pour un annonceur donné et des filtres de recherche
*
* @param {string} id
* @returns {object}
*/
export async function getContactsAnnonce (filter, reference) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser

      let url = '/contacts?annonceur=' + user.advertiser
      if (i18next.language != null) {
        url = url + '&lang=' + i18next.language
      }

      if (reference != null) {
        url = url + '&reference=' + reference
      }

      url = url + '&perPage=' + filter.limit + '&page=' + (filter.offset / filter.limit + 1)

      if (filter.search != null) {
        url = url + '&globalSearch=' + filter.search
      }

      let apiTri = '-date_enregistrement'

      switch (filter.sort) {
        case 'date':
          apiTri = '-date_enregistrement'
          break
        case 'reference':
          apiTri = 'reference'
          break
        case 'identite':
          apiTri = 'identite'
          break
        case 'nomPortail':
          apiTri = 'nomPortail'
          break
      }

      if (filter.beforeContacts != null) {
        const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
        url = url + '&date_min=' + dateBefore
      } else {
        const dateBefore = moment().subtract(7, 'days')
        const before = moment(dateBefore).format('YYYY-MM-DD')
        url = url + '&date_min=' + before
      }

      if (filter.afterContacts != null) {
        const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
        url = url + '&date_max=' + dateAfter
      }

      url = url + '&orderBy=' + apiTri

      return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * Retourne les annonces pour une recherche donnée.
 *
 * @returns {object}
 */
export async function getAnnoncesContacts (filter, allFields) {
  const url = handleUrlAnnonce(filter, allFields)
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return { infos: response.data }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

/**
 * @returns {Promise<{type: string, message: *}>}
 */
export async function getAnnoncesSansContacts (filter, allFields) {
  let url = handleUrlAnnonce(filter, allFields)
  url = url.replace('/annonce?', '/annonce_without_contacts?')
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return { infos: response.data }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export function handleUrlAnnonce (filter, allFields) {
  const user = store.getters.getUser
  let url = ''
  if (allFields === true) {
    url = '/annonce?champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference&annonceur=' + user.advertiser
  } else {
    url = '/annonce?fields=titre,typeObjet,reference,photoPrincipale,dateDisponibilite,nbPortailsActifs,nbContactsMailtracking,etat,annonceParente,typeObjet&champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference&annonceur=' + user.advertiser
  }
  // @see bug #76209 - gestion de la page choisie
  if (filter.pagePosts) {
    url = url + '&perPage=' + filter.limit + '&page=' + filter.pagePosts
  } else {
    url = url + '&perPage=' + filter.limit + '&page=' + (filter.offset / filter.limit + 1)
  }
  if (filter.search != null) {
    url = url + '&rechercheLibre=' + filter.search
  }
  if (filter.beforeContacts != null) {
    const dateBefore = moment(filter.beforeContacts).format('YYYY-MM-DD')
    url = url + '&dateMinContact=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&dateMinContact=' + before
  }
  if (filter.afterContacts != null) {
    const dateAfter = moment(filter.afterContacts).format('YYYY-MM-DD')
    url = url + '&dateMaxContact=' + dateAfter
  }
  if (filter.annonceParente != null) {
    url = url + '&annonce_parente=' + filter.annonceParente
  }
  // en attente d'évol plateforme pour afficher les programmes sans contacts mais qui contiennent des lots avec contacts
  // else {
  //     url = url + "&annonce_parente=" + "00";
  // }
  if (allFields !== true) {
    if (filter.withContacts === true) {
      url = url + '&avecContacts=O'
    }
  }
  if (filter.activeOnly === true) {
    url = url + '&active=O'
  }
  if (filter.refs) {
    url = url + '&refs=' + filter.refs
  }
  if (filter.activeOnly !== true) {
    url = url + '&etat=A,V,M,B'
  }
  let defaultFilter = filter.sort
  if (filter.sort === '-date_enregistrement') {
    defaultFilter = 'R'
  } else if (filter.sort === '-CTM') {
    // ce trie ne fonctionne plus sur sitimmo
    defaultFilter = ''
  } else {
    defaultFilter = filter.sort
  }
  if (defaultFilter) {
    url = url + '&orderBy=' + defaultFilter
  }
  return url
}

/**
* Retourne le nombre de contact journaliers sur un an
*
* @returns {object}
*/
export async function getDailyContacts () {
  const user = store.getters.getUser
  const url = '/contacts_stats_by_period?annonceur=' + user.advertiser + '&period=daily&dataNumber=31'

  return HTTP_HYPER_ESPACE_BACKEND.get(url)
}

/**
* Retourne le nombre de contact mensuel sur un an
*
* @returns {object}
*/
export async function getMonthlyContacts () {
  const user = store.getters.getUser
  const url = '/contacts_stats_by_period?annonceur=' + user.advertiser + '&period=monthly&dataNumber=12'

  return HTTP_HYPER_ESPACE_BACKEND.get(url)
}

export async function getCalls (filters, diffuseur, exporter) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      let url = ''

      url = '/calltracking-calls?annonceur=' + user.advertiser
      /*
            if (i18next.language != null) {
                url = url + "&lang=" + i18next.language;
            }
            */
      if (filters.beforeContacts != null) {
        const dateBefore = moment(filters.beforeContacts).format('YYYY-MM-DD')
        url = url + '&dateStarted=' + dateBefore
      } else {
        const dateBefore = moment().subtract(7, 'days')
        const before = moment(dateBefore).format('YYYY-MM-DD')
        url = url + '&dateStarted=' + before
      }

      if (filters.afterContacts != null) {
        const dateAfter = moment(filters.afterContacts).format('YYYY-MM-DD')
        url = url + '&dateEnded=' + dateAfter
      }

      if (filters.searchCalls !== '') {
        url = url + '&callerNumber=' + filters.searchCalls
      }

      if (filters.rapprochement != null) {
        url = url + '&type=rapprochement'
      }

      if (diffuseur != null && diffuseur.nom_de_code != null) {
        url = url + '&diffuseur=' + diffuseur.nom_de_code
      }

      if (filters.statutAppel !== '') {
        url = url + '&answered=' + filters.statutAppel
      }

      if (filters.sortCalls != null) {
        url = url + '&orderBy=' + filters.sortCalls
      }

      if (filters.limit != null) {
        if (exporter === true) {
          url = url + '&limit=' + '5000'
        } else {
          url = url + '&limit=' + filters.limit
        }
      }

      if (filters.offsetCalls != null) {
        url = url + '&offset=' + filters.offsetCalls
      }

      return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          calls: response.data.calls
        })
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function exportCalls (filters, diffuseur, filename = null) {
  const user = store.getters.getUser
  const sitimmoUser = store.getters.getSitimmoUser
  const normalizedFilters = {}

  normalizedFilters.annonceur = user.advertiser

  if (filters.beforeContacts != null) {
    normalizedFilters.dateStarted = moment(filters.beforeContacts).format('YYYY-MM-DD')
  } else {
    const dateBefore = moment().subtract(7, 'days')
    normalizedFilters.dateStarted = moment(dateBefore).format('YYYY-MM-DD')
  }

  if (filters.afterContacts != null) {
    normalizedFilters.dateEnded = moment(filters.afterContacts).format('YYYY-MM-DD')
  }

  if (filters.searchCalls !== '') {
    normalizedFilters.callerNumber = filters.searchCalls
  }

  if (diffuseur != null && diffuseur.nom_de_code != null) {
    normalizedFilters.diffuseur = diffuseur.nom_de_code
  }

  if (filters.statutAppel !== '') {
    normalizedFilters.answered = filters.statutAppel
  }

  if (filters.sortCalls != null) {
    normalizedFilters.orderBy = filters.sortCalls
  }

  const exportType = 'CONTACT_CALLTRACKING'

  const data = { filters: normalizedFilters, exportType: exportType, to: sitimmoUser.email, filename: filename }

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/export_requests', data)
    .then(response => {
      if (response.status === 202) {
        return { type: 'success', message: $t('layouts.exportSuccess') }
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export async function getNbCalls (filters, diffuseur) {
  const user = store.getters.getUser
  let url = '/calltracking-stats?annonceur=' + user.advertiser

  if (filters.beforeContacts != null) {
    const dateBefore = moment(filters.beforeContacts).format('YYYY-MM-DD')
    url = url + '&dateStarted=' + dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    url = url + '&dateStarted=' + before
  }

  if (filters.afterContacts != null) {
    const dateAfter = moment(filters.afterContacts).format('YYYY-MM-DD')
    url = url + '&dateEnded=' + dateAfter
  }

  if (diffuseur != null && diffuseur.nom_de_code != null) {
    url = url + '&diffuseur=' + diffuseur.nom_de_code
  }

  if (filters.searchCalls !== '') {
    url = url + '&callerNumber=' + filters.searchCalls
  }

  if (filters.statutAppel !== '') {
    url = url + '&answered=' + filters.statutAppel
  }

  if (filters.codeNames != null) {
    url = url + '&orderBy=-nb_calls'
  }

  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return {
      infos: response.data.stats
    }
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export function orderNbCalls (nbCalls) {
  const callsPerPortal = []
  let totalCalls = 0
  nbCalls.infos.forEach(function (element) {
    callsPerPortal[element.diffuseur] = element.nb_calls
    totalCalls = totalCalls + parseInt(element.nb_calls)
  })
  callsPerPortal.TOTAL_CONTACTS_CALLTRACKING = totalCalls

  return callsPerPortal
}

export function generateCodeNamesList (nbCalls) {
  let codeNames = ''
  let i = 0
  nbCalls.infos.forEach(function (element) {
    if (i === 0) {
      codeNames = element.diffuseur
    } else {
      codeNames = codeNames + ',' + element.diffuseur
    }
    i = i + 1
  })
  return codeNames
}
